// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import Notifications from 'ReduxMessenger/reducers/Notifications';
import Auth from './Auth';
import articleContentInfo from './edit/articleContentInfo';
import articleCounts from './manage/articleCounts';
import articleDetailsInfo from './insights/articleDetailsInfo';
import articleFeedbackMaxCounts from './insights/articleFeedbackMaxCounts';
import articleFeedbackReport from './insights/articleFeedbackReport';
import articleVideos from './insights/articleVideos';
import articleVersions from './edit/articleVersions';
import articlesInfo from './manage/articlesInfo';
import authorInfo from './manage/authorInfo';
import categoryOrganizationBuffer from './organize/categoryOrganizationBuffer';
import categoryOrganizationBufferedChanges from './organize/categoryOrganizationBufferedChanges';
import multiLangCategories from './edit/multiLangCategories';
import categoryOrganizationInfo from './edit/categoryOrganizationInfo';
import connectedForms from './connectedForms';
import contentAssistant from './contentAssistant';
import createArticleRequestStatus from './edit/createArticleRequestStatus';
import customerPortalSettings from './customerPortal';
import disabledInteractionsConfig from './disabledInteractionsConfig';
import homepageCategoriesSettings from './homepageCategoriesSettings';
import homepageOrganization from './homepageOrganization';
import importedArticleNeedsReview from './import/importedArticleNeedsReview';
import importWarning from './import/importWarning';
import knowledgeBaseDetails from '../knowledge-base/reducers/knowledgeBaseDetails';
import knowledgeScopes from './knowledgeScopes';
import listsDetail from './listsDetail';
import manageFilters from './manage/manageFilters';
import multiLangRequests from './edit/multiLangRequests';
import organizeEntities from './organize/entities';
import organizeRootCategoriesOrder from './organize/rootCategoriesOrder';
import reportsFilterInfo from './insights/reportsFiltersInfo';
import screenShotDetailsInfo from './insights/screenShotDetailsInfo';
import siteSettings from './siteSettings';
import tags from './tags';
import tagArticlesPanel from './tagArticlesPanel';
import templateEditorReloadPreviewOnSave from './templateEditorReloadPreviewOnSave';
import templateEditorNavigationContext from './templateEditorNavigationContext';
import templateEditorPublishStatus from './templateEditorPublishStatus';
import templatePreview from './templatePreview';
import templatePreviewPlaceholders from './templatePreviewPlaceholders';
import templateSettings from './templateSettings';
import templateSettingsUpdateStatus from './templateSettingsUpdateStatus';
import templateTranslations from './templateTranslations';
import theme from './theme';
import translateTemplateModal from './translateTemplateModal';
import importReducer from '../import/reducers/importReducer';
import selectedEditCategory from './edit/selectedEditCategory';
import resourcesReducer from 'ContentData/reducers/Resources';
export const staticReducers = {
  auth: Auth,
  authorInfo,
  articleContentInfo,
  articleCounts,
  articleDetailsInfo,
  articleFeedbackMaxCounts,
  articleFeedbackReport,
  articleVersions,
  articlesInfo,
  articleVideos,
  categoryOrganizationBuffer,
  categoryOrganizationBufferedChanges,
  multiLangCategories,
  categoryOrganizationInfo,
  createArticleRequestStatus,
  connectedForms,
  contentAssistant,
  customerPortalSettings,
  disabledInteractionsConfig,
  knowledgeScopes,
  knowledgeBaseDetails,
  homepageCategoriesSettings: (state = {}) => state,
  homepageOrganization,
  importKnowledgeBase: importReducer,
  importedArticleNeedsReview,
  importWarning,
  listsDetail,
  organizeEntities,
  organizeRootCategoriesOrder,
  manageFilters,
  multiLangRequests,
  notifications: Notifications,
  reportsFilterInfo,
  screenShotDetailsInfo,
  siteSettings,
  tags,
  tagArticlesPanel,
  templateEditorPublishStatus,
  templateEditorReloadPreviewOnSave,
  templateEditorNavigationContext,
  templatePreview,
  templatePreviewPlaceholders,
  templateSettings,
  templateSettingsUpdateStatus,
  templateTranslations,
  theme,
  translateTemplateModal,
  selectedEditCategory,
  resources: resourcesReducer
};
export const globalStateReducers = [homepageCategoriesSettings];